import { styled } from '../../../config/stitches'
import * as Icons from '../../../icons'

export const CheckBoxIcon = styled(Icons.Check, {
  variants: {
    white: {
      true: {
        color: '$white'
      }
    }
  }
})
